export enum ThemeTypes {
  dark = 'dark',
  light = 'light',
  auto = 'auto',
}
